var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.125 6.417C15.125 8.947 13.28 11 11 11c-2.278 0-4.125-2.052-4.125-4.583 0-2.532 1.847-4.584 4.125-4.584 2.279 0 4.125 2.052 4.125 4.584Zm-1.375 0c0 1.911-1.364 3.208-2.75 3.208S8.25 8.328 8.25 6.417c0-1.912 1.364-3.209 2.75-3.209s2.75 1.297 2.75 3.209ZM18.334 20.167H3.667c-.506 0-.921-.412-.879-.916.347-4.147 3.084-7.334 8.212-7.334 5.129 0 7.866 3.187 8.213 7.334.042.504-.373.916-.88.916Zm-2.387-5.147c.967.93 1.597 2.222 1.829 3.772H4.225c.232-1.55.862-2.843 1.829-3.772 1.073-1.031 2.68-1.728 4.946-1.728 2.268 0 3.873.697 4.947 1.728Z"
  }))));
};
export default SvgUser;